import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Assignment, EmojiEvents, EventAvailable, FitnessCenter, Group, Home, Payment, Person, Restaurant, SupportAgent } from '@mui/icons-material';
import { List } from '@mui/material';
import { CalendarCursor, ChartBoxOutline, NewspaperVariantOutline, TableSearch } from 'mdi-material-ui';
import CollapsibleMenuItem from 'components/shared/menus/CollapsibleMenuItem';
import MenuItem from 'components/shared/menus/MenuItem';
import NestedMenuItem from 'components/shared/menus/NestedMenuItem';
import routes from 'common/routes';
import SidebarPanelContext from 'context/SidebarPanelContext';

function TrainerDesktopMenu() {
  const { t } = useTranslation(['routes', 'pqrs']);
  // Rail colapsado: lo decide el panel host (desktop mini / mobile expandido).
  const { iconOnly: shouldUseIconOnly } = useContext(SidebarPanelContext);

  return (
    <List>
      <MenuItem
        icon={<Home />}
        iconOnly={shouldUseIconOnly}
        itemKey="home"
        label={t('home', { ns: 'routes' })}
        path={routes.trainerDashboard.path}
      />
      <MenuItem
        icon={<NewspaperVariantOutline />}
        iconOnly={shouldUseIconOnly}
        itemKey="news"
        label={t('news.list', { ns: 'routes' })}
        path={routes.listNews.path}
      />
      <MenuItem
        icon={<CalendarCursor />}
        iconOnly={shouldUseIconOnly}
        itemKey="calendar"
        label={t('session.calendar', { ns: 'routes' })}
        path={routes.calendar.path}
      />
      <MenuItem
        icon={<EventAvailable />}
        iconOnly={shouldUseIconOnly}
        itemKey="availability"
        label={t('availability.trainer', { ns: 'routes' })}
        path={routes.availability.path}
      />
      <MenuItem
        icon={<TableSearch />}
        iconOnly={shouldUseIconOnly}
        itemKey="sessions"
        label={t('session.list', { ns: 'routes' })}
        path={routes.listSession.path}
      />
      <MenuItem
        icon={<CalendarCursor />}
        iconOnly={shouldUseIconOnly}
        itemKey="trainerGroupSessions"
        label={t('session.groupSessions', { ns: 'routes' })}
        path={routes.trainerGroupSessions.path}
      />
      <MenuItem
        icon={<Group />}
        iconOnly={shouldUseIconOnly}
        itemKey="client"
        label={t('client.list', { ns: 'routes' })}
        path={routes.listClient.path}
      />
      <MenuItem
        icon={<Restaurant />}
        iconOnly={shouldUseIconOnly}
        itemKey="nutrition-admin"
        label={t('nutrition', { ns: 'routes', defaultValue: 'Nutrición' })}
        path={routes.adminNutrition.path}
      />
      <MenuItem
        icon={<ChartBoxOutline />}
        iconOnly={shouldUseIconOnly}
        itemKey="performance"
        label={t('performance.list', { ns: 'routes' })}
        path={routes.listPerformance.path}
      />
      <MenuItem
        icon={<EmojiEvents />}
        iconOnly={shouldUseIconOnly}
        itemKey="ranking"
        label={t('gamification.globalRanking', { ns: 'routes' })}
        path={routes.globalRanking.path}
      />

      <CollapsibleMenuItem
        icon={<FitnessCenter />}
        iconOnly={shouldUseIconOnly}
        label={t('exercise.exercises', { ns: 'routes' })}
        tourKey="exercises"
        noLink>
        <NestedMenuItem
          label={t('exercise.list', { ns: 'routes' })}
          path={routes.exercises.path}
        />
        <NestedMenuItem
          label={t('exercise.requests', { ns: 'routes' })}
          path={routes.exerciseRequests.path}
        />
      </CollapsibleMenuItem>
      <MenuItem
        icon={<Payment />}
        iconOnly={shouldUseIconOnly}
        itemKey="payment"
        label={t('payment.payments', { ns: 'routes' })}
        path={routes.listTrainerPayments.trainer.path}
      />
      <MenuItem
        icon={<Person />}
        iconOnly={shouldUseIconOnly}
        itemKey="profile"
        label={t('profile', { ns: 'routes' })}
        path={routes.trainerProfile.path}
      />
      <MenuItem
        icon={<Assignment />}
        iconOnly={shouldUseIconOnly}
        itemKey="legal"
        label={t('legal.list', { ns: 'routes' })}
        path={routes.viewTC.path}
      />
      <MenuItem
        icon={<SupportAgent />}
        iconOnly={shouldUseIconOnly}
        itemKey="pqrs"
        label={t('menu', { ns: 'pqrs', defaultValue: 'Soporte (PQRS)' })}
        path={routes.myPqrs.path}
      />
    </List>
  );
}

export default TrainerDesktopMenu;
